<template>
    <div :class="formGroupClasses">
        <label v-if="label" :for="name">{{ label }}</label>
        <div :class="'input-group' + (icon ? ' left-addon' : '')">
        <span v-if="addonBefore" class="input-group-addon" v-html="addonBefore"></span>
            <i v-if="icon" :class="'fa ' + icon"></i>
            <input 
                @change="updateValue($event.target)"
                @input="updateValue($event.target)"
                :id="id" 
                type="checkbox" 
                :class="controlClasses" 
                :name="name" 
                :value="checkedValue" 
                :placeholder="placeholder"
                :checked="isChecked">
        </div>
        
        <span v-if="errors.has(name)" class="form-control-feedback">
            <strong>{{ errors.first(name) }}</strong>
        </span>
        <slot></slot>
        <p v-if="helpText" class="form-text text-muted" v-html="helpText"></p>
    </div>
</template>

<script>
    import FormValidationErrors from '../../../classes/FormValidationErrors.js';

    export default {
        name: 'VueCheckBox',

        props: {

            label: {},

            id: {
                default() { return _.camelCase(this.label); }
            },

            name: {
                default() { return _.kebabCase(this.label).replace('-', '_'); }
            },

            placeholder: {},

            type: {
                default() { return 'text'; }
            },

            helpText: {},

            value: {},

            checkedValue: { default() { return true; }},
            uncheckedValue: { default() { return false; }},

            icon: {},

            addonBefore: { default() { return ''; } },

            errors: {
                default() { return new FormValidationErrors(); }
            },

            classes: {
                default() { return ''; }
            },

            containerClasses: {
                default() { return ''; }
            },
        },

        methods: {

            updateValue(value) {
                if (value.checked) {
                    this.$emit('input', this.checkedValue);
                } else {
                    this.$emit('input', this.uncheckedValue);
                }
            }

        },

        computed: {

            formGroupClasses() {
                return 'form-group form-group-'+ _.kebabCase(this.name) + (this.errors.has(this.name) ? ' has-warning' : '')+ ' '+this.containerClasses;
            },

            controlClasses() {
                return 'form-control' + (this.errors.has(this.name) ? ' form-control-warning' : '') + ' ' + this.classes;
            },

            isChecked() {
                return this.checkedValue === this.value;
            }

        }
    }
</script>